import { render } from "./forgot_password_form.vue?vue&type=template&id=c0b2c97e&class=%20bg-gray-bgcolor%20font-nunito"
import script from "./forgot_password_form.vue?vue&type=script&lang=js"
export * from "./forgot_password_form.vue?vue&type=script&lang=js"

import "./forgot_password_form.vue?vue&type=style&index=0&id=c0b2c97e&lang=css"
script.render = render

export default script